import { Directive, Input } from '@angular/core';
import { CxUiComponentService } from './cx-component.service';

@Directive({
  selector: '[cxInputPropertyBinding]',
  providers: [CxUiComponentService],
})
export class CxInputPropertyBindingDirective {
  constructor(private cxUiComponent: CxUiComponentService<any>) {}

  @Input()
  public set cxInputPropertyBinding(inputs: { [property: string]: unknown }) {
    Object.entries(inputs).forEach(([property, value]) => {
      this.cxUiComponent.setProperty(property, value);
    });
  }
}
